export default "__VITE_ASSET__ce65434b__"